import { ProtectedServerPlaceEvent, PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { accountDeleted, accountDeletionFailed, deleteAccount, DeleteAccountActionType } from '@/store/actions/authentication/deleteAccount';
import getPublicResponse from '@/store/sagas/getPublicResponse';

import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* deleteAccountSaga({ payload }: DeleteAccountActionType) {
  const timestamp = moment();
  const token = payload.token === undefined ? yield getAuthenticationToken() : payload.token;
  const response =
    payload.token === undefined
      ? yield getProtectedResponse(ProtectedServerPlaceEvent.updatePlaceUserDeletionRequestedAt, token, {
          deletionRequestedAt: timestamp.toISOString(),
        })
      : yield getPublicResponse(PublicServerPlaceEvent.updatePlaceUserDeletionRequestedAt, { token, deletionRequestedAt: timestamp.toISOString() });

  if (!response.error) {
    const responseAction = accountDeleted({ timestamp });
    yield put(responseAction);
  } else {
    const responseAction = accountDeletionFailed({ timestamp });
    yield put(responseAction);
  }
}

export default function* watchDeleteAccountSaga() {
  yield takeEvery(deleteAccount, deleteAccountSaga);
}
